'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _reject = require('lodash/reject');

var _reject2 = _interopRequireDefault(_reject);

var _filter = require('lodash/filter');

var _filter2 = _interopRequireDefault(_filter);

var _orderBy = require('lodash/orderBy');

var _orderBy2 = _interopRequireDefault(_orderBy);

var _sortBy = require('lodash/sortBy');

var _sortBy2 = _interopRequireDefault(_sortBy);

var _immutableOps = require('immutable-ops');

var _immutableOps2 = _interopRequireDefault(_immutableOps);

var _constants = require('../constants');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_OPTS = {
    idAttribute: 'id',
    arrName: 'items',
    mapName: 'itemsById'
};

// Input is the current max id and the new id passed to the create action.
// Both may be undefined. The current max id in the case that this is the first Model
// being created, and the new id if the id was not explicitly passed to the
// database.
//
// Return value is the new max id and the id to use to create the new row.
// If the id's are strings, the id must be passed explicitly every time.
// In this case, the current max id will remain `NaN` due to `Math.max`, but that's fine.
function idSequencer(_currMax, userPassedId) {
    var currMax = _currMax;
    var newMax = void 0;
    var newId = void 0;

    if (currMax === undefined) {
        currMax = -1;
    }

    if (userPassedId === undefined) {
        newMax = currMax + 1;
        newId = newMax;
    } else {
        newMax = Math.max(currMax + 1, userPassedId);
        newId = userPassedId;
    }

    return [newMax, // new max id
    newId];
}

/**
 * Handles the underlying data structure for a {@link Model} class.
 */
var Table = function () {
    /**
     * Creates a new {@link Table} instance.
     * @param  {Object} userOpts - options to use.
     * @param  {string} [userOpts.idAttribute=id] - the id attribute of the entity.
     * @param  {string} [userOpts.arrName=items] - the state attribute where an array of
     *                                             entity id's are stored
     * @param  {string} [userOpts.mapName=itemsById] - the state attribute where the entity objects
     *                                                 are stored in a id to entity object
     *                                                 map.
     */
    function Table(userOpts) {
        (0, _classCallCheck3.default)(this, Table);

        (0, _assign2.default)(this, DEFAULT_OPTS, userOpts);
    }

    /**
     * Returns a reference to the object at index `id`
     * in state `branch`.
     *
     * @param  {Object} branch - the state
     * @param  {Number} id - the id of the object to get
     * @return {Object|undefined} A reference to the raw object in the state or
     *                            `undefined` if not found.
     */


    Table.prototype.accessId = function accessId(branch, id) {
        return branch[this.mapName][id];
    };

    Table.prototype.idExists = function idExists(branch, id) {
        return branch[this.mapName].hasOwnProperty(id);
    };

    Table.prototype.accessIdList = function accessIdList(branch) {
        return branch[this.arrName];
    };

    Table.prototype.accessList = function accessList(branch) {
        var _this = this;

        return branch[this.arrName].map(function (id) {
            return _this.accessId(branch, id);
        });
    };

    Table.prototype.getMaxId = function getMaxId(branch) {
        return this.getMeta(branch, 'maxId');
    };

    Table.prototype.setMaxId = function setMaxId(tx, branch, newMaxId) {
        return this.setMeta(tx, branch, 'maxId', newMaxId);
    };

    Table.prototype.nextId = function nextId(id) {
        return id + 1;
    };

    Table.prototype.query = function query(branch, clauses) {
        var _this2 = this;

        var optimizedClauses = (0, _sortBy2.default)(clauses, function (_ref) {
            var type = _ref.type,
                payload = _ref.payload;

            if (type === _constants.FILTER && payload.hasOwnProperty(_this2.idAttribute)) {
                return 1;
            }

            if (type === _constants.FILTER || type === _constants.EXCLUDE) {
                return 2;
            }

            return 3;
        });

        return optimizedClauses.reduce(function (rows, _ref2, index) {
            var type = _ref2.type,
                payload = _ref2.payload;

            switch (type) {
                case _constants.FILTER:
                    {
                        var idAttribute = _this2.idAttribute;

                        var id = payload[idAttribute];

                        if (index === 0 && payload.hasOwnProperty(idAttribute) && id !== null && id !== undefined) {
                            // Payload specified a primary key; Since that is unique, we can directly
                            // return that.
                            return _this2.idExists(branch, id) ? [_this2.accessId(branch, id)] : [];
                        }
                        return (0, _filter2.default)(rows, payload);
                    }
                case _constants.EXCLUDE:
                    {
                        return (0, _reject2.default)(rows, payload);
                    }
                case _constants.ORDER_BY:
                    {
                        var _payload = (0, _slicedToArray3.default)(payload, 2),
                            iteratees = _payload[0],
                            orders = _payload[1];

                        return (0, _orderBy2.default)(rows, iteratees, orders);
                    }
                default:
                    return rows;
            }
        }, this.accessList(branch));
    };

    /**
     * Returns the default state for the data structure.
     * @return {Object} The default state for this {@link Backend} instance's data structure
     */


    Table.prototype.getEmptyState = function getEmptyState() {
        var _ref3;

        return _ref3 = {}, (0, _defineProperty3.default)(_ref3, this.arrName, []), (0, _defineProperty3.default)(_ref3, this.mapName, {}), (0, _defineProperty3.default)(_ref3, 'meta', {}), _ref3;
    };

    Table.prototype.setMeta = function setMeta(tx, branch, key, value) {
        var batchToken = tx.batchToken,
            withMutations = tx.withMutations;

        if (withMutations) {
            var res = _immutableOps2.default.mutable.setIn(['meta', key], value, branch);
            return res;
        }

        return _immutableOps2.default.batch.setIn(batchToken, ['meta', key], value, branch);
    };

    Table.prototype.getMeta = function getMeta(branch, key) {
        return branch.meta[key];
    };

    /**
     * Returns the data structure including a new object `entry`
     * @param  {Object} tx - transaction info
     * @param  {Object} branch - the data structure state
     * @param  {Object} entry - the object to insert
     * @return {Object} an object with two keys: `state` and `created`.
     *                  `state` is the new table state and `created` is the
     *                  row that was created.
     */


    Table.prototype.insert = function insert(tx, branch, entry) {
        var _ops$batch$merge2;

        var batchToken = tx.batchToken,
            withMutations = tx.withMutations;


        var hasId = entry.hasOwnProperty(this.idAttribute);

        var workingState = branch;

        // This will not affect string id's.

        var _idSequencer = idSequencer(this.getMaxId(branch), entry[this.idAttribute]),
            _idSequencer2 = (0, _slicedToArray3.default)(_idSequencer, 2),
            newMaxId = _idSequencer2[0],
            id = _idSequencer2[1];

        workingState = this.setMaxId(tx, branch, newMaxId);

        var finalEntry = hasId ? entry : _immutableOps2.default.batch.set(batchToken, this.idAttribute, id, entry);

        if (withMutations) {
            _immutableOps2.default.mutable.push(id, workingState[this.arrName]);
            _immutableOps2.default.mutable.set(id, finalEntry, workingState[this.mapName]);
            return {
                state: workingState,
                created: finalEntry
            };
        }

        var nextState = _immutableOps2.default.batch.merge(batchToken, (_ops$batch$merge2 = {}, (0, _defineProperty3.default)(_ops$batch$merge2, this.arrName, _immutableOps2.default.batch.push(batchToken, id, workingState[this.arrName])), (0, _defineProperty3.default)(_ops$batch$merge2, this.mapName, _immutableOps2.default.batch.merge(batchToken, (0, _defineProperty3.default)({}, id, finalEntry), workingState[this.mapName])), _ops$batch$merge2), workingState);

        return {
            state: nextState,
            created: finalEntry
        };
    };

    /**
     * Returns the data structure with objects where `rows`
     * are merged with `mergeObj`.
     *
     * @param  {Object} tx - transaction info
     * @param  {Object} branch - the data structure state
     * @param  {Object[]} rows - rows to update
     * @param  {Object} mergeObj - The object to merge with each row.
     * @return {Object}
     */


    Table.prototype.update = function update(tx, branch, rows, mergeObj) {
        var _this3 = this;

        var batchToken = tx.batchToken,
            withMutations = tx.withMutations;
        var mapName = this.mapName;


        var mapFunction = function mapFunction(row) {
            var merge = withMutations ? _immutableOps2.default.mutable.merge : _immutableOps2.default.batch.merge(batchToken);
            return merge(mergeObj, row);
        };

        var set = withMutations ? _immutableOps2.default.mutable.set : _immutableOps2.default.batch.set(batchToken);

        var newMap = rows.reduce(function (map, row) {
            var result = mapFunction(row);
            return set(result[_this3.idAttribute], result, map);
        }, branch[mapName]);
        return _immutableOps2.default.batch.set(batchToken, mapName, newMap, branch);
    };

    /**
     * Returns the data structure without rows `rows`.
     * @param  {Object} tx - transaction info
     * @param  {Object} branch - the data structure state
     * @param  {Object[]} rows - rows to update
     * @return {Object} the data structure without ids in `idsToDelete`.
     */


    Table.prototype.delete = function _delete(tx, branch, rows) {
        var _this4 = this,
            _ops$batch$merge3;

        var batchToken = tx.batchToken,
            withMutations = tx.withMutations;
        var arrName = this.arrName,
            mapName = this.mapName;

        var arr = branch[arrName];

        var idsToDelete = rows.map(function (row) {
            return row[_this4.idAttribute];
        });
        if (withMutations) {
            idsToDelete.forEach(function (id) {
                var idx = arr.indexOf(id);
                if (idx !== -1) {
                    _immutableOps2.default.mutable.splice(idx, 1, [], arr);
                }

                _immutableOps2.default.mutable.omit(id, branch[mapName]);
            });
            return branch;
        }

        return _immutableOps2.default.batch.merge(batchToken, (_ops$batch$merge3 = {}, (0, _defineProperty3.default)(_ops$batch$merge3, arrName, _immutableOps2.default.batch.filter(batchToken, function (id) {
            return !(0, _utils.includes)(idsToDelete, id);
        }, branch[arrName])), (0, _defineProperty3.default)(_ops$batch$merge3, mapName, _immutableOps2.default.batch.omit(batchToken, idsToDelete, branch[mapName])), _ops$batch$merge3), branch);
    };

    return Table;
}();

exports.default = Table;


//////////////////
// WEBPACK FOOTER
// ../~/redux-orm/lib/db/Table.js
// module id = 1128
// module chunks = 0